import { render } from "./RenderLanguageInformationPlay.component.vue?vue&type=template&id=4ccca87e&scoped=true"
import script from "./RenderLanguageInformationPlay.component.vue?vue&type=script&lang=js"
export * from "./RenderLanguageInformationPlay.component.vue?vue&type=script&lang=js"

import "./RenderLanguageInformationPlay.component.vue?vue&type=style&index=0&id=4ccca87e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ccca87e"]])

export default __exports__